const formatNumber = n => Number(n).toLocaleString('en-US')
export default formatNumber
